import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  getEpikBoxData,
  getEpikBoxesData,
  showUpdateEpikBox,
  updateBoxField,
  updateEpikBox,
} from '../../actions/EpikBoxes';
import './BoxOverview.css';
import EditField from './EpikBoxDetails/EditField';
import AddLocationModal from '../AddLocationModal';
import socketIOClient from 'socket.io-client';
import PingModal from '../PingModal';
import { Button } from 'reactstrap';
import { unifiedBaseURL } from '../../lib/api/api';
import Signals from '../Signals';
import Heart from '../../Res/Icon/pulse.png';
import registeredIcon from '../../Res/Icon/registered_icon.png';
import activeCarrierImg from '../../Res/Icon/CarrierIcon.png';
import dataCenter from '../../Res/Icon/data_center.png';
import { ReactComponent as VoltageSvg } from '../../Res/Icon/Voltage.svg';
import { ReactComponent as TempSvg } from '../../Res/Icon/temp.svg';
import SpinnerCircles from '../../../src/components/Spinner/SpinerCircles';

import utils from '../../lib/utils';
const { REACT_APP_LA_SHELL_URL, REACT_APP_CH_SHELL_URL, REACT_APP_NY_SHELL_URL, REACT_APP_AT_SHELL_URL, REACT_APP_DL_SHELL_URL } = process.env
export const dataCenterShellUrls = {
  la: REACT_APP_LA_SHELL_URL,
  ch: REACT_APP_CH_SHELL_URL,
  ny: REACT_APP_NY_SHELL_URL,
  at: REACT_APP_AT_SHELL_URL,
  dl: REACT_APP_DL_SHELL_URL,
};
const BoxCard = (props) => {
  const {
    box = {}, onBoxClick = () => {
    }, valueStyle = {},
  } = props;
  return (
    <div className={props?.boxClass ? props.boxClass : 'boxProperty'} onClick={() => onBoxClick()}
      id="test-model">
      <div className="propertyNameContainer" id="test-model-label">
        {box.icon1?.children ? <>{box.icon1.children}</> :
          <FontAwesomeIcon color="#ffffff" fixedWidth className="labelIcon" icon={box.icon1} />}
        <span className="propertyName">{box.title}</span>
      </div>
      <span className={props.valueClass ? `${props.valueClass}` : 'propertyValue'}
        id="test-model-value" style={valueStyle}>
          {!box.value ? <SpinnerCircles /> : box?.value?.children ? box.value.children : <span dangerouslySetInnerHTML={{__html: box.value}} />}
      </span>
    </div>
  );
};

const BoxOverview = ({
  box,
  updateBoxField,
  boxActiveInterface,
  updateEpikBox,
  user,
  showUpdateEpikBox,
  getEpikBoxData,
  deleteMode,
  eSIMStatus,
  powerState,
  carrier,
  isBoxOnline,
  boxVoltageAndTemp
}) => {
  const token = localStorage.getItem('jwtToken');

  const [addLocationModal, setAddLocationModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pingRes, setPingRes] = useState([]);
  const [processId, setProcessId] = useState('');
  const [stateSocket, setStateSocket] = useState(null);
  const [disablePing, setDisablePing] = useState(false);
  const [deviceDashboardBoxes, setDeviceDashboardBoxes] = useState({
    locationName: box.locRef && box.locRef.locationName,
    serialNumber: box && box?.serialNumber,
    epikEdgeAddress: box && box?.vpnAddress,
    customProvidedIp: box?.customerProvidedIp,
    lteIp1: box.lteIp,
    lteIp2: box.lteIp2,
    status: isBoxOnline,
    signalStrength: null,
    powerState: null,
    vSwitch: null,
    monitoringState: null,
    activeInterface: null,
    activeCarrier: null,
    activeDataCenter: null,
    devicePower: null,
    deviceTemp: null,
  });

  const pingRequest = (serialNumberDash, socket) => {
    console.log('[SOCKET] on : ', serialNumberDash);
    let ping = [];
    socket.on(serialNumberDash, data => {
      if (data.processId) {
        setProcessId(data.processId);
      } else {
        ping = [...ping, data.pingResponse];
        setPingRes(ping);
      }
    });
    setIsOpen(true);
  };

  const handleChange = async (name, value) => {
    updateBoxField(name, value);
    const updateObj = { _id: box._id, [name]: value };

    await updateEpikBox(token, updateObj);
    const boxId = window.location.pathname.split('/').pop();

    await getEpikBoxData(token, boxId);
  };

  useEffect(() => {
    if (box.myEpik) {
      global.myEpik = 'Yes';
    } else {
      global.myEpik = 'No';
    }
  }, []);

  const onAddNewLocation = () => {
    setAddLocationModal(!addLocationModal);
  };

  const boxStatus = (isBoxOnline) => isBoxOnline ? 'Online' : 'Offline';

  const boxMonitoring = () => box.monitor ? 'Monitored' : 'Unmonitored';

  const freeSwitchRegistration = () => box.registered ? 'Registered' : 'Unregistered';

  const locationModal = () => setAddLocationModal(!addLocationModal);
  const onPing = ip => {
    setDisablePing(true);
    const baseUrl = dataCenterShellUrls[box.datacenter];
    const socket = socketIOClient.connect(baseUrl, { query: { token } });
    console.log('CONNECTION SOCKET');
    socket.on('connect', () => {
      setStateSocket(socket);
      console.log('Successfully connected!');
    });
    const { serialNumber } = box;
    const serialNumberDash = `${serialNumber}-${user._id}`;
    console.log('[SOCKET] emit : ', ip);
    socket.emit('PING_REQUEST', { serialNumber: serialNumberDash, ip: ip, shouldStop: false });
    pingRequest(serialNumberDash, socket);
  };

  const handlePingClose = () => {
    console.log('[SOCKET] close : ', processId);
    const { serialNumber } = box;
    setIsOpen(false);
    stateSocket.emit('STOP_PING', { serialNumber: serialNumber, shouldStop: true, processId });
    setProcessId('');
    setPingRes([]);
    setDisablePing(false);
  };

  const handleAbbreviation = (key = '') => {
    console.log('key', key);
    const lowerCase = key.toLowerCase();
    switch (lowerCase) {
      case 'ch':
        return 'CHICAGO';
      case 'la':
        return 'LOS ANGELES';
      case 'ny':
        return 'NEW YORK';
      case 'at':
        return 'ATLANTA';
      case 'nypingavg':
        return 'NY';
        case 'dl':
          return 'DALLAS';
      default:
        return key.toUpperCase();
    }
  };

  const updateDeviceDashboardBoxes = () => {
    const NO_DATA = `<span class="no-data">No Data<span>`;
    setDeviceDashboardBoxes({
      ...deviceDashboardBoxes, 
      locationName: box.locRef && box.locRef.locationName || NO_DATA,
      activeInterface: boxActiveInterface || NO_DATA,
      serialNumber: box && box?.serialNumber || NO_DATA,
      epikEdgeAddress: box && box?.vpnAddress || NO_DATA,
      customProvidedIp: box?.customerProvidedIp || NO_DATA,
      lteIp1: box.lteIp || NO_DATA,
      lteIp2: box.lteIp2 || NO_DATA,
      status: isBoxOnline,
      signalStrength: { children: <Signals /> } || NO_DATA,
      powerState: powerState || NO_DATA,
      vSwitch: freeSwitchRegistration() || NO_DATA,
      monitoringState: boxMonitoring() || NO_DATA,
      activeCarrier: carrier || NO_DATA,
      activeDataCenter: handleAbbreviation(box?.datacenter) || NO_DATA,
      devicePower: boxVoltageAndTemp?.power || NO_DATA,
      deviceTemp: boxVoltageAndTemp?.temperature || NO_DATA,
    });
  }

  useEffect(() => {
    if (isBoxOnline && (powerState || boxActiveInterface || carrier || boxVoltageAndTemp)) {
      updateDeviceDashboardBoxes()
    }
    if (!isBoxOnline) {
      updateDeviceDashboardBoxes()
    }
  }, [box, isBoxOnline, boxVoltageAndTemp, boxActiveInterface, carrier])

  return (
    <div className="boxOverviewContainer">

      <BoxCard box={{ title: 'Active Interface', icon1: 'network-wired', value: deviceDashboardBoxes?.activeInterface }} />

      <BoxCard
        box={{
          title: 'Location Name', icon1: 'map-marker-alt',
          value: deviceDashboardBoxes?.locationName,
        }}
        onBoxClick={onAddNewLocation}
        valueStyle={{ fontSize: box?.locRef?.locationName.length > 14 ? '15px' : '30px' }}
      /> {/* {user.role !== 'admin' && user.role !== 'companyGroupManager' ? (
          <EditField value={box.locRef.locationName || ''} name="locName" handleChange={handleChange} />
        ) : ( */}

      <BoxCard
        box={{
          title: 'Serial Number',
          icon1: 'map-marker-alt',
          value: deviceDashboardBoxes?.serialNumber,
        }}
        // onBoxClick={showUpdateModal}
        valueStyle={{
          fontSize: box.serialNumber ? (box.serialNumber.length > 10 ? '24px' : '32px') : '32px',
        }}
      />

      {(user.role === 'superAdmin' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'supportEngineer' ||
        user.role === 'enterpriseAdmin') && (
          <div className="boxProperty" id="test-epik-edge-address">


            <div
              className="propertyNameContainer"
              // onClick={() => showUpdateModal()}
              id="test-epik-edge-address-label"
            >
              <FontAwesomeIcon
                color="#ffffff"
                fixedWidth
                className="labelIcon"
                icon="network-wired"
              />
              <span className="propertyName">EPIK Edge Address</span>
            </div>

            <span
              className="propertyValue"
              style={{
                fontSize: box.vpnAddress ? (box.vpnAddress.length > 12 ? '24px' : '32px') : '32px',
                height: '55%',
              }}
              // onClick={() => showUpdateModal()}
              id="test-epik-edge-address-value"
              dangerouslySetInnerHTML={{__html: deviceDashboardBoxes?.epikEdgeAddress}}
            />
            <Button
              hidden={!box.vpnAddress}
              className="ping-btn"
              disabled={disablePing}
              onClick={() => onPing(box.vpnAddress)}
              id="test-epik-edge-address-ping-btn"
            >
              <p>ping</p>
            </Button>
          </div>
        )}

      <div className="boxProperty" id="test-customer-provided-ip">
        <div
          className="propertyNameContainer"
          // onClick={() => showUpdateModal()}
          id="test-customer-provided-ip-label"
        >
          <FontAwesomeIcon color="#ffffff" fixedWidth className="labelIcon" icon="ethernet" />
          <span className="propertyName" style={{ fontSize: '14px' }}>
            Customer Provided IP
          </span>
        </div>
        <span
          className="propertyValue"
          style={{
            height: '55%',
            fontSize: box.customerProvidedIp
              ? box.customerProvidedIp.length > 12
                ? '24px'
                : '32px'
              : '32px',
          }}
          // onClick={() => showUpdateModal()}
          id="test-customer-provided-ip-value"
          dangerouslySetInnerHTML={{__html: deviceDashboardBoxes?.customProvidedIp}}
        />
        <Button
          disabled={disablePing}
          hidden={!box.customerProvidedIp}
          className="ping-btn"
          id="test-customer-provided-ip-ping-btn"
          onClick={() => onPing(box.customerProvidedIp)}
        >
          <p>ping</p>
        </Button>
      </div>
      {
        utils.filterCustomer(user?.role) ? (
          <>
            <div className="boxProperty" id="test-lte-ip">
              <div className="propertyNameContainer" //onClick={() => showUpdateModal()}
              >
                <FontAwesomeIcon color="#ffffff" fixedWidth className="labelIcon" icon="ethernet" />
                <span className="propertyName">LTE IP</span>
              </div>
              <span
                style={{
                  height: '55%',
                  fontSize: box.lteIp ? (box.lteIp.length > 12 ? '24px' : '32px') : '32px',
                }}
                className="propertyValue"
                // onClick={() => showUpdateModal()}
                id="test-lte-ip-value"
                dangerouslySetInnerHTML={{__html: deviceDashboardBoxes?.lteIp1}}
             />
              {(box.modems.length === 2 || (eSIMStatus !== null && !eSIMStatus)) && (
                <Button
                  disabled={disablePing}
                  hidden={!box.lteIp}
                  className="ping-btn"
                  onClick={() => onPing(box.lteIp)}
                  id="test-lte-ip-ping-btn"
                >
                  <p>ping</p>
                </Button>
              )}
            </div>
            {box.lteIp2 && (
              <div className="boxProperty" id="test-lte-ip-2">
                <div
                  className="propertyNameContainer"
                  // onClick={() => showUpdateModal()}
                  id="test-lte-ip-2-label"
                >
                  <FontAwesomeIcon color="#ffffff" fixedWidth className="labelIcon" icon="ethernet" />
                  <span className="propertyName">LTE IP 2</span>
                </div>
                <span
                  style={{
                    height: '55%',
                    fontSize: box.lteIp2 ? (box.lteIp2.length > 12 ? '24px' : '32px') : '32px',
                  }}
                  className="propertyValue"
                  // onClick={() => showUpdateModal()}
                  id="test-lte-ip-2-value"
                  dangerouslySetInnerHTML={{__html: deviceDashboardBoxes?.lteIp2}}
                />
                {(box.modems.length === 2 || (eSIMStatus !== null && eSIMStatus)) && (
                  <Button
                    disabled={disablePing}
                    hidden={!box.lteIp2}
                    className="ping-btn"
                    onClick={() => onPing(box.lteIp2)}
                    id="test-lte-ip-2-ping-btn"
                  >
                    <p>ping</p>
                  </Button>
                )}
              </div>
            )}
          </>
        ) : null
      }


      <BoxCard
        box={{
          title: 'Status',
          icon1: { children: <img src={Heart} alt="heart" className="labelIcon" /> },
          value: boxStatus(deviceDashboardBoxes?.status),
        }}
        // onBoxClick={showUpdateModal}
        valueStyle={{ fontSize: boxStatus().length > 10 ? '24px' : '32px' }}
      />

      <BoxCard
        box={{ title: 'Signal Strength', icon1: 'wifi', value: deviceDashboardBoxes?.signalStrength }}
        valueClass={'position-relative h-75 pb-1 d-flex justify-content-center'}
      />

      {powerState && (
        <BoxCard
          box={{ title: 'Power State', icon1: 'power-off', value: deviceDashboardBoxes?.powerState }}
          // onBoxClick={showUpdateModal}
          valueStyle={{ fontSize: powerState?.length > 10 ? '24px' : '32px' }}
        />
      )}

      <BoxCard
        box={{
          title: 'vSwitch',
          icon1: {
            children: <img src={registeredIcon} fixedWidth className="labelIcon" alt={''} />,
          }, value: deviceDashboardBoxes?.vSwitch,
        }}
        valueStyle={{ fontSize: freeSwitchRegistration()?.length > 10 ? '24px' : '32px' }}
      />

      <BoxCard
        box={{
          title: 'Monitoring State', icon1: 'bell', value: deviceDashboardBoxes?.monitoringState,
        }}
        valueStyle={{
          fontSize: boxMonitoring().length > 10 ? '24px' : '32px',
        }}
      />

      <BoxCard
        box={{
          title: 'Active Carrier',
          icon1: {
            children: <img src={activeCarrierImg} fixedWidth className="labelIcon" alt={''} />,
          },
          value: deviceDashboardBoxes?.activeCarrier,
        }}
        valueStyle={{ fontSize: carrier?.length > 10 ? '20px' : '32px' }}
      />
      <BoxCard
        box={{
          title: 'Active Data Center',
          icon1: {
            children: <img src={dataCenter} fixedWidth className="labelIcon" alt={''} height={35} />,
          },
          value: deviceDashboardBoxes?.activeDataCenter,
        }}
        valueStyle={{
          fontSize: box.serialNumber ? (box.serialNumber.length > 10 ? '20px' : '32px') : '32px',
        }}
      />
      <BoxCard
        box={{
          title: 'Device Power',
          icon1: {
            children: <VoltageSvg width={17} />,
          },
          value: deviceDashboardBoxes?.devicePower,
        }}
        valueStyle={{
          fontSize: '32px',
        }}
      />
      <BoxCard
        box={{
          title: 'CPU Temp',
          icon1: {
            children: <TempSvg width={17} />,
          },
          value: deviceDashboardBoxes?.deviceTemp
        }}
        valueStyle={{
          fontSize: '30px',
        }}
      />

      {box?.locRef && (
        <AddLocationModal
          disabled
          formData={box.locRef}
          isOpen={addLocationModal}
          onCancel={locationModal}
        />
      )}
      <PingModal isOpen={isOpen} onCancel={() => handlePingClose()} data={pingRes} user={user}/>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
  deleteMode: state.AppState.deleteMode,
});
const mapDispatchToProps = dispatch => ({
  updateBoxField: (name, value) => dispatch(updateBoxField(name, value)),
  updateEpikBox: (token, box) => dispatch(updateEpikBox(token, box)),
  showUpdateEpikBox: box => dispatch(showUpdateEpikBox(box)),
  getEpikBoxesData: (token, companyId, online) =>
    dispatch(getEpikBoxesData(token, companyId, online)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoxOverview);
